import { render } from "./addRegion.vue?vue&type=template&id=7061b249&scoped=true"
import script from "./addRegion.vue?vue&type=script&lang=js"
export * from "./addRegion.vue?vue&type=script&lang=js"

import "./addRegion.vue?vue&type=style&index=0&id=7061b249&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7061b249"]])

export default __exports__